import { useState, useEffect } from 'react';

// custom hook to determine width of window on initialization and when window is resized
// Determine if window is mobile width as well. Mobile referenced here is for both mobile and tablet 768px
const useViewport = () => {
  const [windowSize, setWindowSize] = useState(window.innerWidth);
  const smallMobileBreakPoint = 480; // breakpoint value from tablet 480 below
  const mobileBreakPoint = 768; // breakpoint value from tablet 768 below
  const bootstrapSmallBreakPoint = 991; // breakpoint added due to Bootstrap's usage in the application; bootstrap sm
  const smallDesktopSizeBreak = 1199; // breakpoint added for boostrap container width breakpoint

  // Determine browser in use by accessing the navigator userAgent
  const agentHas = (keyword) => navigator.userAgent.toLowerCase().search(keyword.toLowerCase()) > -1;

  useEffect(() => {
    const handleWindowResize = () => {
      setWindowSize(window.innerWidth);
    };

    window.addEventListener('resize', handleWindowResize);
    return () => window.removeEventListener('resize', handleWindowResize);
  }, []); // The empty array ensures that the effect is only run on mount

  const isSmallMobile = windowSize < smallMobileBreakPoint;
  const isMobile = windowSize < mobileBreakPoint;
  const isBootstrapSm = windowSize <= bootstrapSmallBreakPoint;
  const isSmallDesktop = windowSize <= smallDesktopSizeBreak;
  const isSafari = (!!window.ApplePaySetupFeature || !!window.safari) && agentHas('Safari') && !agentHas('Chrome') && !agentHas('CriOS');

  return {
    windowSize, isSmallMobile, isMobile, isBootstrapSm, isSmallDesktop, isSafari,
  };
};

export default useViewport;
